import React from 'react';
import { notification } from 'antd';

// Legacy notification functions for utility functions and non-React contexts
export const errorNotification = (errorTitle?: string, errorDescription?: string) => {
	return notify('error', errorTitle, errorDescription);
};

export const infoNotification = (infoTitle?: string, infoDescription?: string) => {
	return notify('info', infoTitle, infoDescription);
};

export const successNotification = (
	succcessTitle?: string,
	successDescription?: string,
	buttons?: React.ReactNode
) => {
	return notify('success', succcessTitle, successDescription, buttons);
};

export const warningNotification = (
	warningTitle?: string,
	warningDescription?: string
) => {
	return notify('warning', warningTitle, warningDescription);
};

const notify = (
	notificationType: 'success' | 'info' | 'error' | 'warning',
	title?: string,
	description?: string,
	buttons?: React.ReactNode
) => {
	notification[notificationType]({
		message: title,
		description,
		btn: buttons,
	});
};
